<template>
	<Transition
		enter-active-class="transition-opacity duration-300 ease-out"
		enter-from-class="opacity-0"
		enter-to-class="opacity-100"
		leave-active-class="transition-opacity duration-200 ease-in"
		leave-from-class="opacity-100"
		leave-to-class="opacity-0"
	>
		<section open class="fixed inset-0 z-3002 flex items-center justify-center">
			<div
				class="absolute top-0 left-0 h-full w-full bg-black/50 backdrop-blur-sm"
				@click="toggleLanguageModal"
				@wheel.prevent
				@touchmove.prevent
				@scroll.prevent
			></div>
			<Transition
				enter-active-class="transition-all duration-400 ease-out"
				enter-from-class="opacity-0 scale-95 translate-y-8"
				enter-to-class="opacity-100 scale-100 translate-y-0"
				leave-active-class="transition-all duration-250 ease-in"
				leave-from-class="opacity-100 scale-100 translate-y-0"
				leave-to-class="opacity-0 scale-95 translate-y-4"
				appear
			>
				<form
					method="dialog"
					class="z-10 min-h-83 w-11/12 max-w-6xl bg-white py-8 px-7 rounded-xl relative shadow-2xl transform-gpu"
				>
					<button
						@click="toggleLanguageModal"
						class="p-2 hover:bg-slate-50 rounded-xl transition-all duration-200 group hover:scale-105 active:scale-95 absolute top-2 right-2"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
							class="w-6 h-6 text-slate-500 group-hover:text-slate-700 transition-all duration-200"
						>
							<line x1="18" y1="6" x2="6" y2="18"></line>
							<line x1="6" y1="6" x2="18" y2="18"></line>
						</svg>
					</button>

					<fieldset>
						<Transition
							enter-active-class="transition-all duration-500 ease-out delay-100"
							enter-from-class="opacity-0 translate-y-[-15px]"
							enter-to-class="opacity-100 translate-y-0"
							appear
						>
							<legend
								class="mb-10 text-1-5lg capitalize text-slate-950 font-bold text-center"
							>
								{{ getTranslations("choose a language") }}
							</legend>
						</Transition>
						<Transition
							enter-active-class="transition-all duration-600 ease-out delay-200"
							enter-from-class="opacity-0 translate-y-[20px]"
							enter-to-class="opacity-100 translate-y-0"
							appear
						>
							<div class="overflow-y-auto max-h-[60vh] sm:max-h-[50vh]">
								<div
									class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3"
								>
									<label
										v-for="(language, index) in languages"
										:key="language.id"
										class="rounded-xl p-4 cursor-pointer flex items-center transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] border-1"
										:class="
											language.id == activeLanguage.id
												? 'bg-blue-500 text-white shadow-sm shadow-blue-500/25 border-blue-500'
												: 'bg-[#F5F5F5] text-gray-900'
										"
										:style="{
											transitionDelay: index * 30 + 'ms',
											animationDelay: index * 30 + 'ms',
										}"
									>
										<input
											type="radio"
											name="language"
											:value="language.id"
											:checked="language.id == activeLanguage.id"
											class="sr-only"
											@change="updateLanguage(language)"
											:aria-checked="language.id == activeLanguage.id"
										/>

										<div
											class="flex-shrink-0 h-6 w-8 rounded-sm overflow-hidden shadow-sm mr-3"
										>
											<img
												:src="language.flag"
												:alt="'Flag of ' + language.title"
												class="h-full w-full object-cover transition-transform duration-200"
											/>
										</div>

										<div class="flex-1 min-w-0">
											<h3 class="text-sm font-medium leading-tight truncate">
												{{ language.title }}
											</h3>
											<div class="flex items-center gap-2 mt-1">
												<span
													class="text-xs truncate"
													:class="
														language.id == activeLanguage.id
															? 'text-blue-100'
															: 'text-gray-600'
													"
												>
													{{ language.title_native }}
												</span>
											</div>
										</div>

										<div
											v-if="language.id == activeLanguage.id"
											class="flex-shrink-0 ml-2"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="20"
												height="20"
												viewBox="0 0 24 24"
												fill="none"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
												class="text-white"
											>
												<polyline points="20,6 9,17 4,12"></polyline>
											</svg>
										</div>
									</label>
								</div>
							</div>
						</Transition>
					</fieldset>
				</form>
			</Transition>
		</section>
	</Transition>
</template>

<script lang="js" src="./LanguageModal.js"></script>
